import { useState, useCallback } from "react";
import { commonPostApi, commonGetApi } from "../../utils/apiService.js";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";
import { showToast } from "../../components/common/toast.js";
import { TOAST_TYPE, COMMON_MSG } from "../../constants/toast";

/**
 * Custom hook for managing campaign and organization data
 * Handles fetching organizations and campaigns
 * 
 * @param {Function} setValue - React Hook Form setValue function
 * @returns {Object} Campaigns data and fetch functions
 */
const useCampaignData = (setValue) => {
  const [campaigns, setCampaigns] = useState([]);

  const fetchCamps = useCallback(async (orgId) => {
    if (!orgId) return;
    
    try {
      const res = await commonPostApi(API_ENDPOINTS.GET_DASHBOARD_CAMP, { 
        organization_id: orgId 
      });
      const campDetails = res?.data?.data?.map((item) => ({
        ...item,
        label: item?.camp_name,
        value: item?.camp_details_id,
      })) || [];
      
      setCampaigns(campDetails);
      
      const savedCampId = localStorage.getItem("camp_id");
      if (savedCampId) {
        setValue("campaign", savedCampId);
      } else if (campDetails?.[0]?.value) {
        setValue("campaign", campDetails?.[0]?.value);
      }
    } catch (error) {
      console.error("Error fetching campaigns:", error);
      showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
    }
  }, [setValue]);

  const fetchOrganizations = useCallback(async () => {
    try {
      const res = await commonGetApi(API_ENDPOINTS.GET_DASHBOARD_ORGANIZATION);
      const orgDetails = res?.data?.data?.map((item) => ({
        ...item,
        label: item?.organization_name,
        value: item?.organization_id,
      })) || [];
      
      if (orgDetails?.[0]?.value) {
        setValue("organization", orgDetails?.[0]?.value);
        await fetchCamps(orgDetails?.[0]?.value);
      }
    } catch (error) {
      console.error("Error fetching organizations:", error);
      showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
    }
  }, [setValue, fetchCamps]);

  return { campaigns, fetchOrganizations, fetchCamps };
};

export default useCampaignData;
